import { cookies, setCookie } from 'sharedKernel/cookies/behavior'
import { INITIALIZE_USER_CONFIG_FORM, RESET_USER_CONFIG_FORM, UPDATE_USER_CONFIG_FORM } from './actions'
import { IUserConfigForm } from './contracts'

export const USER_CONFIG_FORM_INITIAL_STATE: IUserConfigForm = {
  name: { value: '', isRequired: true, isInvalid: false, message: '' },
  email: { value: '', isRequired: false, isInvalid: false, message: '' },
  site: { value: '', isRequired: false, isInvalid: false, message: '' },
  contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
  neighborhood: { value: '', isRequired: true, isInvalid: false, message: '' },
  cnpj: { value: '', isRequired: false, isInvalid: false, message: '' },
  target: { value: '', isRequired: true, isInvalid: false, message: '' },
  phone: { value: '', isRequired: true, isInvalid: false, message: '' },
  mobile: { value: '', isRequired: false, isInvalid: false, message: '' },
  zipcode: { value: '', isRequired: true, isInvalid: false, message: '' },
  lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
  number: { value: '', isRequired: true, isInvalid: false, message: '' },
  lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
  city: { value: '', isRequired: true, isInvalid: false, message: '' },
  state: { value: '', isRequired: true, isInvalid: false, message: '' },
  country: { value: '', isRequired: true, isInvalid: false, message: '' },
  activity: { value: '', isRequired: true, isInvalid: false, message: '' },
  businessModel: { value: '', isRequired: true, isInvalid: false, message: '' },
  employees: { value: '', isRequired: true, isInvalid: false, message: '' },
  technologies: { value: '', isRequired: true, isInvalid: false, message: '' },
  pitch: { value: '', isRequired: true, isInvalid: false, message: '' },
  developmentStage: { value: '', isRequired: true, isInvalid: false, message: '' },
  annualRevenue: { value: '', isRequired: true, isInvalid: false, message: '' },
  hasRaisedInvestment: { value: '', isRequired: true, isInvalid: false, message: '' },
  investmentAmount: { value: '', isRequired: true, isInvalid: false, message: '' },
  investmentOrigin: { value: '', isRequired: true, isInvalid: false, message: '' },
  investmentOtherOrigin: { value: '', isRequired: true, isInvalid: false, message: '' },
  isSimplifiedResolver: { value: '', isRequired: false, isInvalid: false, message: '' },
  termsAccepted: { value: '', isRequired: false, isInvalid: false, message: '' },
  
  // Campos específicos para funcionários da Caixa
  caixaRole: { value: '', isRequired: false, isInvalid: false, message: '' },
  caixaDepartment: { value: '', isRequired: false, isInvalid: false, message: '' },
  caixaEducation: { value: '', isRequired: false, isInvalid: false, message: '' },
  caixaInstitution: { value: '', isRequired: false, isInvalid: false, message: '' },
  caixaMatricula: { value: '', isRequired: true, isInvalid: false, message: '' },
  
  isFormValid: false,

  // Campos de City Hall Admin
  cityHallName: { value: '', isRequired: true, isInvalid: false, message: '' },
  mayorName: { value: '', isRequired: true, isInvalid: false, message: '' },
  teamSize: { value: '', isRequired: true, isInvalid: false, message: '' },
  hasSecretary: { value: '', isRequired: true, isInvalid: false, message: '' },
  secretary: { value: '', isRequired: true, isInvalid: false, message: '' },
  secretaryResponsible: { value: '', isRequired: true, isInvalid: false, message: '' }
}
export interface IHubIUserConfigFormStateAction {
  type: string
  payload: IUserConfigForm
}

export const HubUserConfigFormReducer = (
  state: IUserConfigForm = USER_CONFIG_FORM_INITIAL_STATE,
  action: IHubIUserConfigFormStateAction
): any => {
  switch (action.type) {
    case UPDATE_USER_CONFIG_FORM:
      return {
        ...state,
        ...action.payload
      }

    case RESET_USER_CONFIG_FORM:
      setCookie('_usrData', action.payload)
      return {
        name: { value: '', isRequired: true, isInvalid: false, message: '' },
        phone: { value: '', isRequired: true, isInvalid: false, message: '' },
        mobile: { value: '', isRequired: true, isInvalid: false, message: '' },
        zipcode: { value: '', isRequired: true, isInvalid: false, message: '' },
        lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
        number: { value: '', isRequired: true, isInvalid: false, message: '' },
        lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
        city: { value: '', isRequired: true, isInvalid: false, message: '' },
        state: { value: '', isRequired: true, isInvalid: false, message: '' },
        isFormValid: false
      }
    default:
      return state
  }
}
